import React, { useMemo, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Table from '@awp/components/table';
import { sortByNumericThenAlpha } from '@awp/helpers/sorter';
import { BOOTSTRAP_BREAKPOINTS, checkBreakpoint } from '@awp/helpers/UIHelper';
import { Permissions } from '@awp/constants';
import { hasAccess } from '@components/Authorize';
import { debounce } from '@awp/helpers/Utils';

const ConditionTable = ({ conditions, setShowConditionEditModal, loading, readOnly, setFieldValue }) => {
  const [isMedium, setIsMedium] = useState(checkBreakpoint(BOOTSTRAP_BREAKPOINTS.MEDIUM));
  const [isLarge, setIsLarge] = useState(checkBreakpoint(BOOTSTRAP_BREAKPOINTS.LARGE));

  useEffect(() => {
    const handleResize = debounce(() => {
      setIsMedium(checkBreakpoint(BOOTSTRAP_BREAKPOINTS.MEDIUM));
      setIsLarge(checkBreakpoint(BOOTSTRAP_BREAKPOINTS.LARGE));
    }, 100);

    window.addEventListener('resize-conditionTable', handleResize);

    return () => {
      window.removeEventListener('resize-conditionTable', handleResize);
    };
  });

  const actionMenu = (row) => {
    return (
      <>
        <div>
          {hasAccess([Permissions.WriteAvalancheForm]) && (
            <i
              className="fas fa-edit mx-1 my-1 awp-img-btn"
              title="Edit"
              onClick={() => {
                setShowConditionEditModal({ show: true, data: row.row.original });
              }}
            ></i>
          )}
          {hasAccess([Permissions.WriteAvalancheForm]) && (
            <i
              className="fas fa-trash mx-1 my-1 awp-img-btn"
              title="Delete"
              onClick={() => {
                setFieldValue(row.row.original.Id, {
                  ...row.row.original,
                  ProgramIds: [],
                  AvalancheAreaIds: [],
                  AvalancheAreas: '',
                });
              }}
            ></i>
          )}
        </div>
      </>
    );
  };

  const TableColumns = useMemo(
    () => [
      {
        Header: 'Distribution',
        accessor: 'Distribution',
        sortType: sortByNumericThenAlpha,
      },
      {
        Header: 'Area',
        accessor: 'AvalancheAreas',
        sortType: sortByNumericThenAlpha,
      },
      {
        Header: 'Actions',
        accessor: 'Id',
        disableSortBy: true,
        Cell: readOnly ? <></> : actionMenu,
      },
    ],
    [isLarge, isMedium, readOnly],
  );

  return (
    <>
      <Table
        columns={TableColumns}
        data={!conditions[0] || !conditions[1] ? [] : conditions}
        fetchData={() => {}}
        loading={loading}
        search=""
        filters={[]}
        dataTriggers={[]}
        defaultSortBy={'Distribution'}
        showPagination={false}
      />
    </>
  );
};

ConditionTable.propTypes = {
  conditions: PropTypes.array,
  setShowConditionEditModal: PropTypes.func,
  setFieldValue: PropTypes.func,
  loading: PropTypes.bool,
  readOnly: PropTypes.bool,
};

export default ConditionTable;
